import styled from 'styled-components'

export const ResponsiveImage = styled.img`
  max-width: 100%;
`
